// NOTE: This file is used by both the browser and NodeJS tooling code of this repo.
//       Please keep this file free of code tying it to either environment.

export const DEV_SSO_URL = "https://dev.sso.granular.ag";
export const TEST_SSO_URL = "https://test.sso.granular.ag";
export const PROD_SSO_URL = "https://sso.granular.ag";

export const PROD_URL = "https://us.insights.granular.ag";
export const TEST_URL = "https://us.test.insights.granular.ag";
export const DEV_URL = "https://us.dev.insights.granular.ag";

export const MIN_PORT_FOR_PROXYING_TO_TEST_API = 4000;
export const MAX_PORT_FOR_PROXYING_TO_TEST_API = 4009;
// NOTE: Don't jump up to 5000, it is used by Control Center on macOS
export const MIN_PORT_FOR_PROXYING_TO_PROD_API = 4040;
export const MAX_PORT_FOR_PROXYING_TO_PROD_API = 4049;

export const URL_TO_SSO_URL_MAPPING: Record<string, string> = {
  [DEV_URL]: DEV_SSO_URL,
  [TEST_URL]: TEST_SSO_URL,
  [PROD_URL]: PROD_SSO_URL,
};
export const VALID_URLS_FOR_PROXING_API_TO = Object.keys(
  URL_TO_SSO_URL_MAPPING,
);
